import type { MapRegion } from "@/types"

export const ursusRegion: MapRegion = {
    id: "ursus",
    name: "map.region.ursus",
    mapImage: require("@/assets/imgs/map/ursus/map-ursus.png"),
    decoImage: require("@/assets/imgs/map/ursus/map-ursus-deco.png"),
    startNodeId: "us-start",
    endNodeId: "us-end",
    startDirection: "right",
    unlocked: false,
    order: 2,
    iconConfig: {
        question: {
            highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-question-mark.png"),
            width: 210,
            height: 198,
        },
    },
    nodes: [
        {
            id: "us-start",
            type: "start",
            level: 0,
            position: { x: 160, y: 155 },
            iconType: "question",
        },
        {
            id: "us-evt1",
            type: "event",
            level: 1,
            position: { x: 206, y: 455 },
            eventId: "evt-us-01",
            iconType: "question",
        },
        {
            id: "us-evt3",
            type: "event",
            level: 1,
            position: { x: 489, y: 212 },
            eventId: "evt-us-03",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-event-3.png"),
                width: 390,
                height: 303,
            },
        },
        {
            id: "us-poca",
            type: "event",
            level: 2,
            position: { x: 370, y: 620 },
            eventId: "dlg-us-poca",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-event-poca.png"),
                width: 319,
                height: 280,
            },
        },
        {
            id: "us-udon",
            type: "event",
            level: 2,
            position: { x: 821, y: 146 },
            eventId: "dlg-us-udon",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-event-udon.png"),
                width: 290,
                height: 292,
            },
        },
        {
            id: "us-evt5",
            type: "event",
            level: 3,
            position: { x: 712, y: 354 },
            eventId: "evt-us-05",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-event-5.png"),
                width: 408,
                height: 391,
            },
        },
        {
            id: "us-evt4",
            type: "event",
            level: 3,
            position: { x: 894, y: 646 },
            eventId: "evt-us-04",
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-event-4.png"),
                width: 409,
                height: 281,
            },
        },
        {
            id: "us-evt2",
            type: "event",
            level: 3,
            position: { x: 1251, y: 251 },
            eventId: "evt-us-02",
            iconType: "question",
        },
        {
            id: "us-end",
            type: "end",
            level: 4,
            position: { x: 1333, y: 610 },
            iconType: "building",
            iconOverride: {
                highlightIcon: require("@/assets/imgs/map/ursus/map-ursus-target.png"),
                width: 182,
                height: 210,
            },
        },
    ],
    edges: [
        { from: "us-start", to: "us-evt1", waypoints: [] },
        { from: "us-start", to: "us-evt3", waypoints: [{ x: 160, y: 212 }] },
        { from: "us-evt1", to: "us-poca", waypoints: [{ x: 206, y: 620 }] },
        { from: "us-evt3", to: "us-udon", waypoints: [] },
        { from: "us-poca", to: "us-evt5", waypoints: [] },
        { from: "us-poca", to: "us-evt4", waypoints: [] },
        { from: "us-udon", to: "us-evt5", waypoints: [] },
        { from: "us-udon", to: "us-evt2", waypoints: [] },
        { from: "us-evt5", to: "us-end", waypoints: [{ x: 1000, y: 354 }] },
        { from: "us-evt4", to: "us-end", waypoints: [] },
        { from: "us-evt2", to: "us-end", waypoints: [] },
    ],
}
